import React from 'react'
import CommerceBoxMiniCart from './CommerceBoxMiniCart'
import CommerceBoxXS from './CommerceBoxXS'
import CommerceBoxMD from './CommerceBoxMD'
import CommerceBoxLG from './CommerceBoxLG'
import * as T from './CommerceBox.types'
import CommerceBoxTile from './CommerceBoxTile'
import CommerceBoxStage from './CommerceBoxStage'
import CommerceBoxPromo from './CommerceBoxPromo'

const CommerceBox = ({
  product,
  type,
  CTAButton,
  WishlistButton,
  innerRef,
  onDelete,
  onQuantityChange,
  onVariantChange,
  onAddToCart,
  noPadding,
  showTaxesInfo,
  smallDiscountPrice,
  isPDP,
  isDarkMode,
  PromoCode,
  isMobile,
  showLowestPrice = false
}: T.CommerceBoxProps) => {
  if (!product) {
    return <></>
  }

  if (product?.c_isBonusProductsByPromoCode && PromoCode) {
    if (isPDP) {
      return <CommerceBoxPromo product={product} PromoCode={PromoCode} />
    } else {
      return <></>
    }
  }

  switch (type) {
    case 'miniCart':
      return (
        <CommerceBoxMiniCart
          CTAButton={CTAButton}
          WishlistButton={WishlistButton}
          innerRef={innerRef}
          product={product}
          onDelete={onDelete}
          onQuantityChange={onQuantityChange}
          showLowestPrice={showLowestPrice}
        />
      )
    case 'XS':
      return (
        <CommerceBoxXS
          CTAButton={CTAButton}
          WishlistButton={WishlistButton}
          innerRef={innerRef}
          product={product}
          onAddToCart={onAddToCart}
          showLowestPrice={showLowestPrice}
        />
      )
    case 'MD':
      return (
        <CommerceBoxMD
          isPDP={isPDP}
          CTAButton={CTAButton}
          WishlistButton={WishlistButton}
          innerRef={innerRef}
          product={product}
          showTaxesInfo={showTaxesInfo}
          smallDiscountPrice={smallDiscountPrice}
          onAddToCart={onAddToCart}
          onVariantChange={onVariantChange}
          noPadding={noPadding}
          showLowestPrice={showLowestPrice}
        />
      )
    case 'LG':
      return (
        <CommerceBoxLG
          isPDP={isPDP}
          CTAButton={CTAButton}
          WishlistButton={WishlistButton}
          innerRef={innerRef}
          product={product}
          onAddToCart={onAddToCart}
          onVariantChange={onVariantChange}
          noPadding={noPadding}
          wishlistButtonOnRight={true}
          showLowestPrice={showLowestPrice}
        />
      )
    case 'TILE':
      return (
        <CommerceBoxTile
          isPDP={isPDP}
          CTAButton={CTAButton}
          innerRef={innerRef}
          product={product}
          onAddToCart={onAddToCart}
          noPadding={noPadding}
          showLowestPrice={showLowestPrice}
        />
      )
    case 'Stage':
      return (
        <CommerceBoxStage
          CTAButton={CTAButton}
          innerRef={innerRef}
          product={product}
          showTaxesInfo={showTaxesInfo}
          smallDiscountPrice={smallDiscountPrice}
          onAddToCart={onAddToCart}
          onVariantChange={onVariantChange}
          isDarkMode={isDarkMode}
          isMobile={isMobile}
          showLowestPrice={showLowestPrice}
        />
      )
    default:
      return <></>
  }
}

export default CommerceBox
